import { Card, CardContent, Typography, Box, IconButton, Button } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { useRef } from "react";
import { useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
function EquipmentCards() {
  const { t } = useTranslation();
const cards = [
  { image: "https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_9421-Photoroom.png-Photoroom.png", title: t("EquipmentCards.cards.title") },
  { image: "https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_9632-Photoroom.png-Photoroom.png", title: t("EquipmentCards.cards.title2") },
  { image: "https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_1731-Photoroom.png-Photoroom.png", title: t("EquipmentCards.cards.title3"), },
  { image: "https://www.remora.com.tr/wp-content/uploads/2025/05/88.png", title: t("EquipmentCards.cards.title4"), },
  { image: "https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_9471-Photoroom.png-Photoroom.png", title: t("EquipmentCards.cards.title5"), },
  { image: "https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_9733-Photoroom.png-Photoroom.png", title: t("EquipmentCards.cards.title6"), },
  { image: "https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_9412-Photoroom.png-Photoroom.png", title:t("EquipmentCards.cards.title7"), },
  { image: "https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_9419-Photoroom.png-Photoroom.png", title: t("EquipmentCards.cards.title8"),},
  { image: "https://www.remora.com.tr/wp-content/uploads/2025/05/IMG_1761-Photoroom.png-Photoroom.png", title: t("EquipmentCards.cards.title9"), },
  { image: "https://www.remora.com.tr/wp-content/uploads/2024/05/2-kopyasi-1.png", title: t("EquipmentCards.cards.title10"), },
  { image: "https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_9423-Photoroom.png-Photoroom.png", title: t("EquipmentCards.cards.title11"),},
];


  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const isMobile = useMediaQuery("(max-width:600px)");

  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: direction === "left" ? -250 : 250, behavior: "smooth" });
    }
  };

  const handleButtonClick = () => {
    navigate("/urunler"); // Ürünler sayfasına yönlendir
  };

  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", mt: 4 }}>
      <Typography variant="h4" sx={{ textAlign: "center", fontWeight: "bold", color: "#000000", mb: 3 }}>
      {t('EquipmentCards.Equipments')}
      </Typography>

      <Box
        ref={scrollRef}
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: 2,
          padding: "10px",
          overflowX: isMobile ? "visible" : "hidden",
          width: "100%",
          maxWidth: "1200px",
          justifyContent: isMobile ? "center" : "flex-start",
          alignItems: "center",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {cards.map((card, index) => (
          <Card
            key={index}
            sx={{
              width: "100%",
              maxWidth: "240px",
              height: "360px",
              flexShrink: 0,
              borderRadius: "12px",
              boxShadow: 2,
              cursor: "pointer",
              transition: "transform 0.3s ease",
              "&:hover": { transform: "scale(1.05)" },
              marginBottom: isMobile ? "20px" : "0",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <CardContent sx={{ padding: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
              <img
                src={card.image}
                alt={card.title}
                style={{ width: "220px", height: "220px", objectFit: "contain", borderRadius: "12px", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)" }}
              />
              <Typography variant="h6" sx={{ mt: 2, textAlign: "center", fontWeight: "bold", color: "#000000" }}>
                {card.title}
              </Typography>
            </CardContent>
            <Box sx={{ textAlign: "center", pb: 5 }}>
              <Button 
                variant="contained" 
                color="primary" 
                sx={{ textTransform: "none", borderRadius: "8px" }} 
                onClick={handleButtonClick}
              >
               {t('EquipmentCards.button')}
              </Button>
            </Box>
          </Card>
        ))}
      </Box>

      {!isMobile && (
        <>
          <IconButton 
  onClick={() => scroll("left")} 
  sx={{
    position: "absolute", 
    left: "calc(50% - 650px)", // Kartlar arasındaki mesafeyi dikkate alarak sola yakınlaştırdık
    zIndex: 1, 
    backgroundColor: "rgba(0,0,0,0.5)", 
    borderRadius: "50%", 
    color: "white", 
    "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" }
  }}
>
  <ArrowBackIos />
</IconButton>

<IconButton 
  onClick={() => scroll("right")} 
  sx={{
    position: "absolute", 
    right: "calc(50% - 650px)", // Kartlar arasındaki mesafeyi dikkate alarak sağa yakınlaştırdık
    zIndex: 1, 
    backgroundColor: "rgba(0,0,0,0.5)", 
    borderRadius: "50%", 
    color: "white", 
    "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" }
  }}
>
  <ArrowForwardIos />
</IconButton>

        </>
      )}
    </Box>
  );
}

export default EquipmentCards;
